module.exports = __webpack_public_path__ + "static/blog-post-1-b577936de014805e33cdc63dd9626189.png";